import { render, staticRenderFns } from "./base-slide.vue?vue&type=template&id=7e07ca7d&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/johndwells/Git/hys/penge-polls/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e07ca7d')) {
      api.createRecord('7e07ca7d', component.options)
    } else {
      api.reload('7e07ca7d', component.options)
    }
    module.hot.accept("./base-slide.vue?vue&type=template&id=7e07ca7d&", function () {
      api.rerender('7e07ca7d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/vue/base/base-slide.vue"
export default component.exports